import { Trans } from '@lingui/react/macro';
import React from 'react';
import { formatTimeHM } from '../utils/dateTimeUtils';

function DepartureTime(props) {
    if(!props.fromTime) {
        return null;
    }

    return (
        <div>
            <Trans id="time">Time</Trans>: {formatTimeHM(props.fromTime)}
            {props.endTime && (
                <>
                    {" "}- {formatTimeHM(props.endTime)} 
                </>
            )}
        </div>
    );
}

export default DepartureTime;